import http from './http.js'; // 导入http中创建的axios实例

const Api = {
    // 获取职位详情
    getPosition(data) {
        return http.get('/position/findPositionById', { params: { id: data } })
    },
    // 获取团队详情
    getTeam(data) {
        return http.get('/team/getTeamAllInfo', { params: { teamId: data } })
    },
    // 获取公司详情
    getCompany(data) {
        return http.get('comInfo/queryByid', { params: { id: data } })
    },
    // 获取批推详情
    getPitui(data) {
        return http.get('rcpt/queryRcptDetail', { params: { id: data } })
    },
    // 获取批招详情
    getPizhao(data) {
        return http.get('rcpz/queryRcpzDetail', { params: { id: data } })
    },
    // 获取招聘会详情
    getZhaopin(data) {
        return http.get('trainJobfair/getTrainJobFairById',  { params: { id: data } })
    },
    // 获取培训城详情
    getPeixun(data) {
        return http.get('trainJobfair/getTrainJobFairById',  { params: { id: data } })
    }
}

export default Api